import seaweed from './img/sea/seaweed.png';
import sea_grapes from './img/sea/sea_grapes.png';
import sea_cucumber from './img/sea/sea_cucumber.png';
import sea_pig from './img/sea/sea_pig.png';
import sea_star from './img/sea/sea_star.png';
import sea_urchin from './img/sea/sea_urchin.png';
import slate_pencil_urchin from './img/sea/slate_pencil_urchin.png';
import sea_anemone from './img/sea/sea_anemone.png';
import moon_jellyfish from './img/sea/moon_jellyfish.png';
import sea_slug from './img/sea/sea_slug.png';
import pearl_oyster from './img/sea/pearl_oyster.png';
import mussel from './img/sea/mussel.png';
import oyster from './img/sea/oyster.png';
import scallop from './img/sea/scallop.png';
import whelk from './img/sea/whelk.png';
import turban_shell from './img/sea/turban_shell.png';
import abalone from './img/sea/abalone.png';
import gigas_giant_clam from './img/sea/gigas_giant_clam.png';
import chambered_nautilus from './img/sea/chambered_nautilus.png';
import octopus from './img/sea/octopus.png';
import umbrella_octopus from './img/sea/umbrella_octopus.png';
import vampire_squid from './img/sea/vampire_squid.png';
import firefly_squid from './img/sea/firefly_squid.png';
import gazami_crab from './img/sea/gazami_crab.png';
import dungeness_crab from './img/sea/dungeness_crab.png';
import snow_crab from './img/sea/snow_crab.png';
import red_king_crab from './img/sea/red_king_crab.png';
import acorn_barnacle from './img/sea/acorn_barnacle.png';
import spider_crab from './img/sea/spider_crab.png';
import tiger_prawn from './img/sea/tiger_prawn.png';
import sweet_shrimp from './img/sea/sweet_shrimp.png';
import mantis_shrimp from './img/sea/mantis_shrimp.png';
import spiny_lobster from './img/sea/spiny_lobster.png';
import lobster from './img/sea/lobster.png';
import giant_isopod from './img/sea/giant_isopod.png';
import horseshoe_crab from './img/sea/horseshoe_crab.png';
import sea_pineapple from './img/sea/sea_pineapple.png';
import spotted_garden_eel from './img/sea/spotted_garden_eel.png';
import flatworm from './img/sea/flatworm.png';
import venus_flower_basket from './img/sea/venus_flower_basket.png';

export const seaData = [
  { name: "Seaweed", image: seaweed },
  { name: "Sea Grapes", image: sea_grapes },
  { name: "Sea Cucumber", image: sea_cucumber },
  { name: "Sea Pig", image: sea_pig },
  { name: "Sea Star", image: sea_star },
  { name: "Sea Urchin", image: sea_urchin },
  { name: "Slate Pencil Urchin", image: slate_pencil_urchin },
  { name: "Sea Anemone", image: sea_anemone },
  { name: "Moon Jellyfish", image: moon_jellyfish },
  { name: "Sea Slug", image: sea_slug },
  { name: "Pearl Oyster", image: pearl_oyster },
  { name: "Mussel", image: mussel },
  { name: "Oyster", image: oyster },
  { name: "Scallop", image: scallop },
  { name: "Whelk", image: whelk },
  { name: "Turban Shell", image: turban_shell },
  { name: "Abalone", image: abalone },
  { name: "Gigas Giant Clam", image: gigas_giant_clam },
  { name: "Chambered Nautilus", image: chambered_nautilus },
  { name: "Octopus", image: octopus },
  { name: "Umbrella Octopus", image: umbrella_octopus },
  { name: "Vampire Squid", image: vampire_squid },
  { name: "Firefly Squid", image: firefly_squid },
  { name: "Gazami Crab", image: gazami_crab },
  { name: "Dungeness Crab", image: dungeness_crab },
  { name: "Snow Crab", image: snow_crab },
  { name: "Red King Crab", image: red_king_crab },
  { name: "Acorn Barnacle", image: acorn_barnacle },
  { name: "Spider Crab", image: spider_crab },
  { name: "Tiger Prawn", image: tiger_prawn },
  { name: "Sweet Shrimp", image: sweet_shrimp },
  { name: "Mantis Shrimp", image: mantis_shrimp },
  { name: "Spiny Lobster", image: spiny_lobster },
  { name: "Lobster", image: lobster },
  { name: "Giant Isopod", image: giant_isopod },
  { name: "Horseshoe Crab", image: horseshoe_crab },
  { name: "Sea Pineapple", image: sea_pineapple },
  { name: "Spotted Garden Eel", image: spotted_garden_eel },
  { name: "Flatworm", image: flatworm },
  { name: "Venus' Flower Basket", image: venus_flower_basket },
];

export default seaData;